export const escalationLevelOptions = [
  {
    value: 0,
    label: 'No Message Sent',
  },
  {
    value: 1,
    label: 'First Called',
  },
  {
    value: 2,
    label: 'Second Called',
  },
  {
    value: 3,
    label: 'Third Called',
  },
  {
    value: 4,
    label: 'Fourth Called',
  },
  {
    value: 5,
    label: 'Fifth Called',
  },
];

export const workDays = [
  { value: '7', label: 'Sun' },
  { value: '1', label: 'Mon' },
  { value: '2', label: 'Tue' },
  { value: '3', label: 'Wed' },
  { value: '4', label: 'Thu' },
  { value: '5', label: 'Fri' },
  { value: '6', label: 'Sat' },
];

export const active = [
  { value: true, label: 'Active' },
  { value: false, label: 'Inactive' },
];
